import React from 'react'
import CardWithHeader from 'components/CardWithHeader'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'
import Responses from 'post-responses/Responses'
import ResponsesIcon from 'icons/ResponsesIcon'
import { ReactFC } from 'types'

import { useResponsesDataContext } from './ResponsesDataContext'
import { usePostLoaded } from 'posts/posts.selectors'

interface ResponsesCardProps {

}

const ResponsesCard: ReactFC<ResponsesCardProps> = ({ children }) => {
  const { responses, loading, error, order } = useResponsesDataContext()
  const post = usePostLoaded()
  if (!post) {
    return null
  }
  const titleId = () => {
    if(post.type === "discussion") {
      return "post.responses_discussion"
    }
    return "post.responses"
  }

  return (
    <CardWithHeader title={titleId()} icon={ResponsesIcon}
      cardProps={{ "data-intro": "send" }}>
      {children}
      <LoadingLoadedOrExploded
        loading={!responses && loading}
        error={error && error.message}
        loaded={{ responses, order, }}
        loadedComponent={Responses}
      />
    </CardWithHeader>
  )
}


export default ResponsesCard
